import ApiService from './api.service';

export default {
  deleteSkeletonPointer(pointer) {
    return ApiService.delete(`appointments/${pointer.visitId}/skeletons/${pointer.partToDel}`);
  },
  addSkeletonPointers(pointer) {
    return ApiService.post(`appointments/${pointer.visitId}/skeletons`, {
      skeletonIds: [pointer.partToAdd],
    });
  },
  getSkeletonPointer(id) {
    return ApiService.get(`appointments/${id}/skeletons`);
  },
  getSkeletonsParts() {
    return ApiService.get('/skeleton/elements');
  },
};



// WEBPACK FOOTER //
// ./src/services/skeleton.service.js